export default __webpack_public_path__ + "47c2bf4b30638c53e84e83cf77d28f2d.png";